import { render, staticRenderFns } from "./ModalCafDetail.vue?vue&type=template&id=2e2ce52c"
import script from "./ModalCafDetail.vue?vue&type=script&lang=js"
export * from "./ModalCafDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports